<script lang="ts" setup>
import Link1 from '@/components/Button/Link1.vue'
import type { IHighlight } from '@/utils/types'
import InfiniteMarque from '@/utils/Marque'


const props = defineProps({
  data: {
    type: Array as PropType<Array<IHighlight>>,
    default: []
  }
})

onMounted(() => {
  if (process.client) {
    new InfiniteMarque({ element: document.querySelectorAll('.zonezoneBox5__slide') })
  }
})
</script>

<template>
  <section class="zonezoneBox5" ref="refZonezoneBox5">
    <div class="zonezoneBox5__top" data-aos="fade-up" data-aos-duration="1500">
      <div class="zonezoneBox5__top__enTitle">fun events</div>
      <div class="zonezoneBox5__top__twTitle">活動花絮</div>
    </div>
    <div class="zonezoneBox5__slide">
      <div class="zonezoneBox5__slide__box">
        <template v-for="(item, index) in data">
          <figure class="zonezoneBox5__slide__img h__pic isShow" :class="`zonezoneBox5__slide__img${index + 1}`">
            <Nimg :src="item.image?.link" :alt="item.image?.alt" :title="item.image?.title" />
          </figure>
        </template>
      </div>
    </div>
    <div class="zonezoneBox5__link">
      <Link1 to="/events" color="white" bg="black">更多活動</Link1>
    </div>
  </section>
</template>

<style lang="scss" scoped>
@keyframes infiniteSlide {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-50%);
  }
}

.zonezoneBox5 {
  margin-bottom: toRem(20);
  margin-left: toRem(-24);
  margin-right: toRem(-24);
  overflow: hidden;

  &__top {
    position: relative;
    z-index: 1;
    text-align: center;
    color: $color-white-1;

    @include max-media(990) {
      margin-bottom: toRem(28);
      width: 50%;
      margin-left: auto;
      margin-right: auto;
      display: flex;
      flex-direction: column;
      text-align: center;
      gap: toRem(12);
    }

    &__enTitle {
      line-height: 0.9;
      font-family: $font-TextaAlt;
      // font-size: toRem(158);
      font-size: 10vw;
      font-weight: 500;
      letter-spacing: toRem(-3.16);

      @include max-media(990) {
        font-size: toRem(80);
      }
    }

    &__twTitle {
      line-height: 1;
      // font-size: toRem(48);
      font-size: 3.1vw;
      font-weight: 500;

      @include max-media(990) {
        font-size: toRem(28);
      }
    }
  }

  &__link {
    display: flex;
    justify-content: center;
    padding-top: toRem(30);
    padding-bottom: toRem(15);
  }

  &__slide {
    display: flex;
    width: max-content;
    // animation: infiniteSlide 10s linear infinite;

    @include min-media(991) {
      margin-top: toRem(-100);
    }

    &__box {
      display: flex;
      align-items: flex-start;
      width: calc(100vw * 1.45);
      flex-shrink: 0;

      @include max-media(990) {
        width: calc(100vw * 1.80);

      }
    }

    &__img {
      position: relative;
      margin-right: toRem(24);
      background-color: #282828;

      img {
        position: absolute;
        left: 0;
        top: 0;
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    &__img1 {
      width: 25%;
      padding-top: calc(25% * 1.05);
    }

    &__img2 {
      width: 20%;
      padding-top: calc(20% * 1.02);
    }

    &__img3 {
      width: 34%;
      padding-top: calc(34% * 0.66);
    }

    &__img4 {
      width: 21%;
      padding-top: calc(21% * 1.32);
    }
  }
}
</style>
